module.exports = __webpack_public_path__ + "static/img/Frame(14).7edb2c10.png";